import { useWebRTCContext } from '@double-bagel/webrtc-wrapper';

type DataListener = (participantId: string, data: unknown) => void;
type OpenListener = (participantId: string) => void;
const noSubscription = () => () => {};

/**
 * The room's data channel (webrtc-wrapper, branch room-data-channel): send to
 * the other side, listen to it, and hear when a peer's channel opens. Against
 * an older wrapper build that has no channel, every call is a quiet no-op:
 * the match video does not sync, and the room still works.
 */
export function useRoomData(): {
  sendData: (data: unknown, to?: string) => number;
  onData: (listener: DataListener) => () => void;
  onDataChannelOpen: (listener: OpenListener) => () => void;
} {
  const ctx = useWebRTCContext() as Partial<{
    sendData: (data: unknown, to?: string) => number;
    onData: (listener: DataListener) => () => void;
    onDataChannelOpen: (listener: OpenListener) => () => void;
  }>;
  return {
    sendData: ctx.sendData ?? (() => 0),
    onData: ctx.onData ?? noSubscription,
    onDataChannelOpen: ctx.onDataChannelOpen ?? noSubscription,
  };
}
